
import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import * as AOS from 'aos';
import { Title, Meta } from '@angular/platform-browser';

import { Constants } from '../../common/constants';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-smarter-salesforce-strategy',
  templateUrl: './smarter-salesforce-strategy.component.html',
  styleUrl: './smarter-salesforce-strategy.component.css'
})
export class SmarterSalesforceStrategyComponent {
 baseUrl=Constants.baseUrl;
  isBrowser:boolean=false;  
 constructor(
    private titleService: Title,  @Inject(PLATFORM_ID) private platformId: any,
    private _renderer2: Renderer2,private seoService:SeoService,
    @Inject(DOCUMENT) private _document: Document,
    private metaService: Meta
  ) {this.isBrowser=isPlatformBrowser(this.platformId);}
  ngOnInit() {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/salesforce-strategy/"
  },
  "headline": "What is smart manufacturing, and how is it changing the industry?",
  "description": "The modern manufacturing landscape is rapidly evolving, challenging manufacturers to meet increasing customer demands while integrating cutting-edge digital tools into their facilities.",
  "image": "https://mitresource.com/assets/images/blogs/smart-manufacturing-blog.webp",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-07-18"
}`;
   
    this._renderer2.appendChild(this._document.head, script);
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
if(this.isBrowser){     
  AOS.init({disable: 'mobile', duration: 2000, delay: 500,});
}
    
  }
 

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('What is smart manufacturing, and how is it changing the industry?');

    this.metaService.addTags([
      { name: 'description', content: 'The modern manufacturing landscape is rapidly evolving, challenging manufacturers to meet increasing customer demands while integrating cutting-edge digital tools into their facilities.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'What is smart manufacturing, and how is it changing the industry?' },
      { property: 'og:url', content: 'https://mitresource.com/salesforce-strategy/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/blogs/smart-manufacturing-blog.webp' },
      { property: 'og:description', content: 'The modern manufacturing landscape is rapidly evolving, challenging manufacturers to meet increasing customer demands while integrating cutting-edge digital tools into their facilities.' },
    ]);
  }
}
